export default __webpack_public_path__ + "static/media/log-out.cc777b90.png";